const skill_data = [
  {
    id: 1,
    skillName: 'HTML',
    skill_percentage: '85%' 
  },
  {
    id: 2,
    skillName: 'CSS',
    skill_percentage: '80%' 
  },
  {
    id: 3,
    skillName: 'Tailwind CSS',
    skill_percentage: '75%' 
  },
  {
    id: 4,
    skillName: 'Bootstrap',
    skill_percentage: '85%' 
  },
  {
    id: 5,
    skillName: 'Material UI',
    skill_percentage: '70%' 
  },
  {
    id: 6,
    skillName: 'JavaScript',
    skill_percentage: '70%' 
  },
  {
    id: 7,
    skillName: 'React JS',
    skill_percentage: '80%' 
  },
  {
    id: 8,
    skillName: 'TypeScript',
    skill_percentage: '65%' 
  },
  {
    id: 9,
    skillName: 'Redux',
    skill_percentage: '95%' 
  },
  {
    id: 10,
    skillName: 'Next JS',
    skill_percentage: '70%' 
  },
  {
    id: 11,
    skillName: 'Node JS',
    skill_percentage: '70%' 
  },
  {
    id: 12,
    skillName: 'Firebase',
    skill_percentage: '70%' 
  },
  {
    id: 13,
    skillName: 'Express JS',
    skill_percentage: '50%' 
  },
  {
    id: 14,
    skillName: 'Mongoose',
    skill_percentage: '65%' 
  },
  {
    id: 15,
    skillName: 'MongoDB',
    skill_percentage: '65%' 
  },
  {
    id: 16,
    skillName: 'Prisma',
    skill_percentage: '60%' 
  },
  {
    id: 17,
    skillName: 'PostgreSQL',
    skill_percentage: '65%' 
  },
  {
    id: 18,
    skillName: 'GitHub',
    skill_percentage: '75%' 
  },
]

export default skill_data;